import { apiFetcher } from '~/apis/api-fetcher';

import { FavoriteFoldersResponse } from './models';

export type FavoriteFoldersParams = {
  sort?: string;
};

/** 찜 폴더 목록 조회 */
export const getFavoriteFolders = (params: FavoriteFoldersParams = {}, requestInit?: RequestInit) =>
  apiFetcher.get<FavoriteFoldersResponse>('/api/pms/v2/favorite-folders', params, requestInit);
